// source: witbooking/backoffice/reportqueries/v1/reportqueries_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.reportqueries.v1.ReportQueries', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.displayName = 'proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.displayName = 'proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.reportqueries.v1.ReportQueries, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.reportqueries.v1.ReportQueries.displayName = 'proto.witbooking.backoffice.reportqueries.v1.ReportQueries';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    page: jspb.Message.getFieldWithDefault(msg, 3, 0),
    size: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest;
  return proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} returns this
*/
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} returns this
*/
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 size = 4;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesRequest.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    reportList: jspb.Message.toObjectList(msg.getReportList(),
    proto.witbooking.backoffice.reportqueries.v1.ReportQueries.toObject, includeInstance),
    totalResults: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse;
  return proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.reportqueries.v1.ReportQueries;
      reader.readMessage(value,proto.witbooking.backoffice.reportqueries.v1.ReportQueries.deserializeBinaryFromReader);
      msg.addReport(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReportList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.reportqueries.v1.ReportQueries.serializeBinaryToWriter
    );
  }
  f = message.getTotalResults();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated ReportQueries report = 1;
 * @return {!Array<!proto.witbooking.backoffice.reportqueries.v1.ReportQueries>}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.getReportList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.reportqueries.v1.ReportQueries>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.reportqueries.v1.ReportQueries, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.reportqueries.v1.ReportQueries>} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse} returns this
*/
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.setReportList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.addReport = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.reportqueries.v1.ReportQueries, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.clearReportList = function() {
  return this.setReportList([]);
};


/**
 * optional int32 total_results = 2;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.getTotalResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.GetReportQueriesResponse.prototype.setTotalResults = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.reportqueries.v1.ReportQueries.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    ip: jspb.Message.getFieldWithDefault(msg, 2, ""),
    checkIn: (f = msg.getCheckIn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    checkOut: (f = msg.getCheckOut()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    nights: jspb.Message.getFieldWithDefault(msg, 5, 0),
    occupancy: jspb.Message.getFieldWithDefault(msg, 6, 0),
    adults: jspb.Message.getFieldWithDefault(msg, 7, 0),
    children: jspb.Message.getFieldWithDefault(msg, 8, 0),
    babies: jspb.Message.getFieldWithDefault(msg, 9, 0),
    locale: jspb.Message.getFieldWithDefault(msg, 10, ""),
    hasAvailability: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    isChain: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.reportqueries.v1.ReportQueries;
  return proto.witbooking.backoffice.reportqueries.v1.ReportQueries.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCheckIn(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCheckOut(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNights(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOccupancy(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdults(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildren(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBabies(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasAvailability(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsChain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.reportqueries.v1.ReportQueries.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCheckIn();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCheckOut();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNights();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOccupancy();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAdults();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getChildren();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getBabies();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getHasAvailability();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsChain();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
*/
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ip = 2;
 * @return {string}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp check_in = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getCheckIn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
*/
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setCheckIn = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.clearCheckIn = function() {
  return this.setCheckIn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.hasCheckIn = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp check_out = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getCheckOut = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
*/
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setCheckOut = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.clearCheckOut = function() {
  return this.setCheckOut(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.hasCheckOut = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 nights = 5;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getNights = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setNights = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 occupancy = 6;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 adults = 7;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 children = 8;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getChildren = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setChildren = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 babies = 9;
 * @return {number}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getBabies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setBabies = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string locale = 10;
 * @return {string}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool has_availability = 11;
 * @return {boolean}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getHasAvailability = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setHasAvailability = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool is_chain = 12;
 * @return {boolean}
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.getIsChain = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.reportqueries.v1.ReportQueries} returns this
 */
proto.witbooking.backoffice.reportqueries.v1.ReportQueries.prototype.setIsChain = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.reportqueries.v1);
